module.exports = __webpack_public_path__ + "static/media/slider-l6.7f8585b0.webp";